import client from './client'
import { OrderDetails, GetOrderParams, OrderListResponse } from '@/types'

export const getOrderList = (params: GetOrderParams) => {
  return client<OrderListResponse<OrderDetails>>({
    url: 'orders',
    method: 'GET',
    params,
  })
}

export const getOrderDetail = (params: { order_code: string; org_id: string }) => {
  return client<OrderDetails>({
    url: 'order',
    method: 'GET',
    params,
  })
}

export const cancelOrder = (data: { order_code: string }) => {
  return client<{ order_code: string }>({
    url: 'orders/close',
    method: 'PUT',
    data,
  })
}

export const getPaymentUrl = (params: {
  order_code: string
  pay_type: number
  referral_code?: string
  coupon_code?: string
}) => {
  return client<{ url: string }>({
    url: 'order/pay-url',
    method: 'GET',
    params,
  })
}

export const postOrderConfirm = (data: { order_code: string; coupon_code?: string; referral_code?: string }) => {
  return client({
    url: 'order/confirm',
    method: 'POST',
    data,
  })
}
export const postOrder0Pay = (data: { order_code: string; coupon_code: string }) => {
  return client({
    url: 'order/coupon/pay',
    method: 'POST',
    data,
  })
}

export const voucherCodePurchase = (data: {
  order_code: string
  redeem_code?: string
  pay_type: number
  referral_code?: string
  coupon_code?: string
  receipt_url?: string
  company: string
}) => {
  return client<unknown>({
    url: 'pay-order',
    method: 'POST',
    data,
  })
}

export const postApplyInvoice = (data: {
  order_code: string
  invoice_type: string //  1.普通发票 2.增值税专用发票
  unit_name: string
  taxpayer_id: string
  unit_address: string
  bank_name: string
  bank_account: string
}) => {
  return client<unknown>({
    url: 'order/invoice',
    method: 'POST',
    data,
  })
}

export const getReferralCode = (params: { referral_code: string }) => {
  return client<{ url: string }>({
    url: `order/referral/${params.referral_code}`,
    isAlert: false,
    method: 'GET',
    params,
  })
}

export const getCouponCode = (params: { coupon_code: string; order_code: string }) => {
  return client<{ url: string }>({
    isAlert: false,
    url: `order/coupon/${params.coupon_code}`,
    method: 'GET',
    params,
  })
}

export const postUploadPayReceipt = (data: { order_code: string; receipt: File }) => {
  return client<{ receipt_url: string }>({
    url: `order/${data.order_code}/payment-receipt`,
    method: 'POST',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export const getCoupons = (params: { order_code: string }) => {
  return client<any>({
    url: 'coupons',
    method: 'GET',
    params,
  })
}

export const getPublicAccount = (params: { order_code: string }) => {
  return client<any>({
    url: 'order/public-account',
    method: 'GET',
    params,
  })
}
